import { Context } from "../context";
import { FieldVisionController } from "./FieldVisionController";
import { SPEED_CONFIG } from "./FieldVisionController";
import CameraControls from "camera-controls";

export class Keyboard {
  context: Context;
  controller: FieldVisionController;
  camera?: CameraControls;

  constructor(controller: FieldVisionController, context: Context) {
    this.context = context;
    this.controller = controller;
    this.camera = context.cameraController?.controls;

    window.addEventListener("keydown", (event) => this.handleButtons(event));
  }

  handleButtons(event: KeyboardEvent) {
    if (!this.context.keyboardEnabled) return;
    switch (event.key) {
      case " ":
        event.preventDefault();
        this.context.state.playing = !this.context.state.playing;
        break;
      case "f":
        this.context.callbacks.onFullscreen(!this.context.state.isFullscreen);
        this.context.state.isFullscreen
          ? this.controller.exitFullscreen()
          : this.controller.enterFullscreen();
        break;
      case "v":
        let index = Math.max(
          0,
          SPEED_CONFIG.findIndex((s) => s.value == this.context.clock.speed)
        );
        this.context.clock.speed =
          SPEED_CONFIG[(index + 1) % SPEED_CONFIG.length].value;
        break;
      case "i":
        this.context.callbacks.onInfoButton();
        break;
      case "c":
        this.controller.nextCameraMode();
        break;
    }
  }

  teardown() {
    window.removeEventListener("keydown", (event) => this.handleButtons(event));
  }
}
